export var UserSex;
(function (UserSex) {
    UserSex["MALE"] = "0";
    UserSex["FEMALE"] = "1";
})(UserSex || (UserSex = {}));
